// "What's new" on /platform#whats-new. Hand-curated from brain/log.md
// for a buyer, newest first. `lead` is the longer notes (Oct 15–22);
// the default export is the shorter rest of the month. A `to` is only
// set when that page actually shows the thing. Art keys live in
// components/WhatsNewArt.js.

export const WHATS_NEW_LEAD = [
  {
    date: '2026-11-05',
    title: 'Live production support on Kit Enterprise',
    place: 'App Kit',
    art: 'proof',
    to: '/app-kit#enterprise-support',
    body: [
      'Kit Enterprise named support now says what it means on the site: nventr operators can run Dev Console on your instance while users stay on production — feedback to a reviewed diff, preview and verifier, UAT, and production on your promote gate, plus queue and worker recovery in the envelope.',
      'Self-serve Kit still means you run Dev Console yourself. Platform Pilot is unchanged — your first gated pipeline into systems you already run, not live app feature work. Capability copy only; no customer story on the page yet.',
    ],
  },
  {
    date: '2026-11-04',
    title: 'The site in depth',
    place: 'nventr.io',
    art: 'proof',
    to: '/dev-console',
    body: [
      'Dev Console has its own page: the loop on the real views, seven groups of what you can do with the view and the plan on each, the trust ladder, a week with it, what it costs at your volume, the limits a fresh instance runs with, what you need, how it compares with the usual way, and the measured numbers with their source. Every module page can carry the same depth; nQube, agentOS, Agent IO, nventr Agent, Listen and DevOps do now.',
      'Knowledge, Integrations and Human Review have pages of their own; Security is a real page; /app-kit follows the app’s life from design to ownership; /pricing works three monthly examples per product and shows where each module is, read from the same record the module pages show.',
    ],
  },
  {
    date: '2026-11-02',
    title: 'Agents that prove their work',
    place: 'Dev Console',
    art: 'proof',
    to: '/dev-console',
    body: [
      'A change used to come back as a diff and a green check. Now a verifier agent opens the preview in a real browser, drives the feature the way a person would, and pins a verdict to the exact commit it drove, screenshots attached. A newer push makes that verdict stale, never passing. When the verdict is red, the agent that made the change gets the failing check and another turn, up to a budget, and the verifier runs again on the new head.',
      'Before a pull request merges you can ask for a review graph: several verifiers, some directed by the feature map, one reading the diff and distrusting the description, then a judge from a different model family than the one that wrote the code. The Ship strip\'s Review step is green only at the head the judge read. Graphs also fan a task list out to parallel workers, or race model families on one ask and let a judge pick the base. Routines open sessions from causes on their own: a failing self-test, a thumbs-down, a report from the control plane, the weekly gardener. One setting says how far it goes alone: confirm, verify, autopilot. The default is confirm.',
    ],
  },
  {
    date: '2026-10-22',
    title: 'Bring the app you already have',
    place: 'App Kit',
    art: 'adopt',
    to: '/app-kit#bring',
    body: [
      'Point a GitHub repository at a new instance. We read it and host it in the shape it actually is. A layer is mirrored. A kit fork contributes only the seams you agree to keep. Any other stack comes up as a preview, with your repository checked out read-only beside a fresh layer.',
      'The token stays in our vault. Change requests are Dev Console sessions on that instance. Your database, users, and files stay where they are. Cutover, when you choose it, is the domain you already use, and we keep checking the old address until then. A preview that is not yet a layer does not cut over on its own.',
    ],
  },
  {
    date: '2026-10-22',
    title: 'The studio catches up with the build',
    place: 'Dev Console',
    art: 'catchup',
    to: '/dev-console',
    body: [
      'App Builder and the Dev Console used to share an app and not a memory. After a session on the instance, catch-up asks that instance for a short digest of the sessions, plans, pull requests, and deploys, and proposes a concept, ideas, and stories. You accept them. Nothing is filed as decided until you do.',
      'The return trip is one story at a time. You send that story to the instance, the build runs there, and the studio shows when it landed. An older instance that cannot write the digest still gets a draft from the conversations, and the run says so.',
    ],
  },
  {
    date: '2026-10-22',
    title: 'Every policy change keeps a number',
    place: 'Administration',
    art: 'policy',
    body: [
      'Guardrails, who reviews a write, permissions, the controls on sandbox, UAT, and production, monthly cost limits, and the model ladder each used to overwrite the last value. A change is now a revision: the version, what it was, what it is, who changed it, and why.',
      'Restore puts an earlier version back as a new revision. The old one stays in the list. Approving a teammate’s request to raise a monthly limit is the same kind of revision. These maps can no longer be written from the browser. They go through the API, and the audit trail shows them next to deploys.',
    ],
  },
  {
    date: '2026-10-21',
    title: 'Secrets you write once',
    place: 'Dev Console',
    art: 'secrets',
    to: '/app-kit#dev-console',
    body: [
      'The layer can declare the keys it needs. In Dev Console you set a value, and the panel does not show it again. A reserved name is refused. The audit log stores the name.',
      'The UAT twin can receive the same names over the deploy link between the two instances. Production and UAT stay separate apps. The values are not printed on either screen.',
    ],
  },
  {
    date: '2026-10-21',
    title: 'Routing is a workflow you draw',
    place: 'nQube',
    art: 'router',
    to: '/platform/nqube',
    body: [
      'Which model handles a call can be an nQube pipeline. The request comes in, a rule or a decision picks a tier, and the only result is that choice. The pipeline is not allowed to write anywhere.',
      'You author it where you author other workflows. It ships with the app, and the hosted instance can run it as the router. The tiers, the caps, and a key you bring are unchanged. This is how the choice is drawn. How those tiers behave is on the gate page.',
    ],
  },
  {
    date: '2026-10-21',
    title: 'The month, on one page',
    place: 'The organization',
    art: 'economics',
    body: [
      'Economics, in the org console, puts three figures for the month side by side: what the fleet cost, what the plan would bill at list, and what was actually invoiced. It refreshes through the month.',
      'There is no new price in this. List prices stay on Pricing. The page is so an admin can read the month without rebuilding a spreadsheet.',
    ],
  },
  {
    date: '2026-10-21',
    title: 'Voice on a paid Kit, and a code at the door',
    place: 'Kit and Kit Business',
    art: 'voice',
    body: [
      'Kit and Kit Business include the voice agent, with a monthly allowance. Past the allowance, sessions draw credits you add. Plans outside those two can still add voice on their own.',
      'A referral code can grant credits and waive the plan fee for a Platform plan, a Kit plan, or both, for the term written on the code. Enter it on the start page, or later under Billing.',
    ],
  },
  {
    date: '2026-10-21',
    title: 'The fleet makes room, and it watches the box',
    place: 'The fleet',
    art: 'fleet',
    to: '/app-kit#fleet',
    body: [
      'A paid App Kit used to stop if every server was full. It now waits with “Adding a server…” while the fleet launches one, and the stamp continues when that server is up.',
      'Each service has a memory cap. The host reports memory and restarts every minute, and an incident opens on pressure, a burst of restarts, or an out-of-memory kill. An operator can move a live app onto another server, database included. A kit update reaches the fleet after a canary instance passes a test suite built from that app’s screens, data, and tools.',
    ],
  },
  {
    date: '2026-10-17',
    title: 'NoVA can see the page, and use it',
    place: 'nventr Agent',
    art: 'hands',
    to: '/platform/nventr-agent',
    body: [
      'NoVA reads the screen you are on: the page, what is in view, and the controls. In a voice session it can scroll, type, and press the same controls you can.',
      'Anything that spends money, deploys, deletes, or cannot be undone stays yours. Those controls are marked, and NoVA is refused there even when it can point at them. The same hands exist in the console and on a hosted app.',
    ],
  },
  {
    date: '2026-10-16',
    title: 'Report a bug. Ask for a feature. Hear when it ships.',
    place: 'Your account',
    art: 'bugs',
    body: [
      'From the Help menu (the account menu inside an organization), Report a bug sends the screen you were on and any files you attach. A person reviews it. A coding agent can open the pull request. You are mailed when the fix ships to production.',
      'A feature request lands on a shared board, is triaged, and can take the same path: a plan, a pull request, a check on UAT, then production. You can see the requests you filed.',
    ],
  },
];

const WHATS_NEW = [
  {
    date: '2026-11-02',
    title: 'Graphs of sessions',
    art: 'graph',
    body: 'One Dev Console session can become a graph: a task list fanned out to parallel workers, each with its own pull request; the same ask raced across model families with a judge picking the base; or a pull request reviewed by independent verifiers and a judge from another family. The Graphs view draws it live.',
    to: '/dev-console',
  },
  {
    date: '2026-11-02',
    title: 'Routines and the trust ladder',
    art: 'ladder',
    body: 'Routines turn a cause into one session: a failing self-test case, a verify loop that gave up, a thumbs-down, a note the runtime filed, a report handed over from the control plane, a weekly gardener pass over merged changes. One fix per cause, bounded by a daily budget. dev.autonomy says what runs on its own: confirm plans only, verify opens pull requests and reviews every one, autopilot ships behind a green review.',
    to: '/dev-console',
  },
  {
    date: '2026-10-17',
    title: 'A book layout on a foldable',
    art: 'fold',
    body: 'Between a phone and a laptop, the console keeps a slim navigation column and the work beside it. This site does the same, and so does Dev Console.',
    to: '/app-kit',
  },
  {
    date: '2026-10-14',
    title: 'Chat, images, and video',
    art: 'models',
    body: 'One catalog on Platform and on App Kit: chat, embeddings, images, and video. Each plan includes a monthly allowance; past it, calls draw credits you add. At zero the app stays up, and keys you bring are never paused.',
    to: '/gate#routing',
  },
  {
    date: '2026-10-14',
    title: 'A live room for every app',
    art: 'room',
    body: 'Open the room and watch a request travel from the door to the service that answered. MCP, mail, voice, and the rest are doors, and you can replay the last few minutes.',
    to: '/demo/room',
  },
  {
    date: '2026-10-14',
    title: 'Ask from the site',
    art: 'support',
    body: 'Send a question signed out or signed in. When something already written answers it, you see that draft and its sources — and a person on the team has it either way.',
    to: '/support',
  },
  {
    date: '2026-10-14',
    title: 'The first build, on the instance',
    art: 'build',
    body: 'Launch the app and NoVA offers to build the screens from the concept you already accepted. You approve the plan; the session runs in that instance’s Dev Console.',
    to: '/dev-console',
  },
  {
    date: '2026-10-14',
    title: 'The order stays on screen',
    art: 'checkout',
    body: 'Start keeps the plan beside signup and the agreement. The last agree opens checkout with the organization and the grant already written.',
    to: '/pricing',
  },
  {
    date: '2026-10-13',
    title: 'Every instance is an MCP server',
    art: 'mcp',
    body: 'Cursor, Claude, and ChatGPT connect to the hosted app with a token or a sign-in. They get the same tools as the in-app assistant, under that person’s own seat.',
    to: '/app-kit#mcp',
  },
  {
    date: '2026-10-12',
    title: 'Knowledge connectors',
    art: 'connectors',
    body: 'SharePoint, Confluence, Google Drive, Notion, S3, and a website crawl sync into Knowledge on a schedule. Documents arrive as drafts and keep versions.',
    to: '/platform/athena',
  },
];

export default WHATS_NEW;
